import { DateTime } from "luxon";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { ExternaLink } from "../../../assets/icons/Externalink";
import Flag from "../../../assets/icons/Flag";
import Search from "../../../assets/icons/Search";
import Input from "../../../components/general/Input";

import {
  Container,
  TableContainer,
  Table,
  StatusFormat,
  TaskDate,
  TRLine,
  TDACC,
  Label,
} from "./styles";

function millisParaDataString(millis) {
  return DateTime.fromMillis(millis).toFormat("dd/MM/yyyy");
}

const toSearch = (searchTerm) => (item) =>
  item.label.toLowerCase().includes(searchTerm.toLowerCase());

export const TaskTable = ({ stats, style }) => {
  const [search, setSearch] = useState("");

  const history = useHistory();
  const getStatus = (task) => {
    const status = task.moment.currentStatus;

    return status === "doing"
      ? "Em dia"
      : status === "pending"
        ? "Pendente"
        : status === "done"
          ? "Concluído"
          : status === "doneLate"
            ? "C. Atraso"
            : "Atrasado";
  };

  const numberOfDays = (item) =>
    item.expiration.number === 24
      ? (item.expiration.number / 24).toFixed(1) + " dia"
      : (item.expiration.number / 24).toFixed(1) + " dias";

  const SearchList = [...stats.doing, ...stats.done].filter(toSearch(search));

  const pushToDashboard = (task) => {
    const status =
      task.moment.currentStatus === "doneLate"
        ? "done"
        : task.moment.currentStatus;
    const query = new URLSearchParams({ taskId: task._id, status });
    history.push(`/tasks?${query}`, { notification: task._id });
  };

  return (
      <Container style={style}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "0.5rem",
          }}
        >
          <Input
            style={{ width: "15rem", background: "#eee" }}
            Icon={() => <Search />}
            placeholder="Pesquisar Tarefa..."
            value={search}
            setValue={setSearch}
          />
        </div>
        <TableContainer>
          <Table>
            <thead className="table-head">
              <tr className="first-line">
                <th>N</th>
                <th>Tarefa</th>
                <th>D. Inicio</th>
                <th>Duração</th>
                <th>D. Conclusão</th>
                <th>Status</th>
                <th>Projeto</th>
              </tr>
            </thead>
            <tbody>
              {SearchList.map((item, index) => (
                <TRLine key={item._id}>
                  <td>{index + 1}</td>
                  <td>
                    <Label onClick={() => pushToDashboard(item)}>
                      {item.label}
                    </Label>
                  </td>
                  <td>
                    {millisParaDataString(item.startedAt)}
                  </td>
                  <td>{numberOfDays(item)}</td>
                  <td>
                    <TaskDate status={item.moment.currentStatus}>
                      <Flag />
                      {item.status === "doing"
                        ? millisParaDataString(item.expiration.date)
                        : millisParaDataString(item.finishedAt)}
                    </TaskDate>
                  </td>
                  <td>
                    <StatusFormat status={item.moment.currentStatus}>
                      {getStatus(item)}
                    </StatusFormat>
                  </td>
                  <TDACC>{item.projectInfo?.title}</TDACC>
                </TRLine>
              ))}
            </tbody>
          </Table>
        </TableContainer>
      </Container>
  );
};
